import React from 'react';

function RiskDisclosure() {
  return (
    <main className="bg-white">
      <section className="pt-28 pb-14">
        <div className="max-w-4xl mx-auto px-6 space-y-12">
          <header>
            <h1 className="text-3xl sm:text-4xl font-semibold text-gray-900">Risk Disclosure</h1>
            <p className="mt-3 text-gray-600 max-w-2xl">Investing involves risk, including possible loss of principal. Please review the following disclosures carefully.</p>
          </header>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">1. Market Risk</h2>
            <p className="mt-3 text-gray-600">Securities fluctuate with market conditions and may decline in value due to economic, political, or issuer-specific events.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">2. Interest Rate & Credit Risk</h2>
            <p className="mt-3 text-gray-600">Fixed income securities are subject to interest rate risk; credit risk may result in defaults or downgrades impacting prices and income.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">3. Liquidity Risk</h2>
            <p className="mt-3 text-gray-600">Some instruments may be thinly traded or subject to restrictions, leading to wider spreads or delays in execution.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">4. Foreign & Emerging Markets</h2>
            <p className="mt-3 text-gray-600">Exposure to currency movements, political instability and lower disclosure standards can increase volatility and risk.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">5. Alternatives & Derivatives</h2>
            <p className="mt-3 text-gray-600">Strategies using leverage, derivatives or private assets may entail heightened complexity, valuation, and liquidity risks.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">6. Digital Assets</h2>
            <p className="mt-3 text-gray-600">Cryptoassets are highly volatile and may be impacted by regulatory changes, technology failures, hacks, and market sentiment. Custody, key management, and on/off‑ramp availability are critical considerations.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">7. Diversification</h2>
            <p className="mt-3 text-gray-600">Diversification does not ensure profits or protect against losses in declining markets. Past performance is not indicative of future results.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">8. Suitability</h2>
            <p className="mt-3 text-gray-600">Investments should align with your objectives, risk tolerance, time horizon and financial situation. Review your plan regularly and update us after major life events.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">9. Fees & Conflicts</h2>
            <p className="mt-3 text-gray-600">Fees reduce returns over time. Review fee schedules and understand potential conflicts of interest disclosed in our materials.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">10. No Guarantee</h2>
            <p className="mt-3 text-gray-600">There are no guarantees that objectives will be achieved. Any targets or projections are estimates subject to change.</p>
          </div>

          <div>
            <p className="text-gray-500 text-sm">Effective date: {new Date().toLocaleDateString()}</p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default RiskDisclosure;



